import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Alert } from '../../services';
import { CircleRunningIcon } from '../icons/IconProvider';

const ManualKycModal = ({ isOpen, onClose, onSubmit, userId }) => {
  const validationSchema = Yup.object().shape({
    manualKycNote: Yup.string()
      .required('Please enter the manual KYC reason')
      .min(3, 'KYC note must be at least 3 characters long'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmitForm = async (data) => {
    try {
      await onSubmit({ userId, manualKycNote: data.manualKycNote });
      reset();
      onClose();
    } catch (error) {
      Alert.error(error.message || 'Failed to submit KYC note');
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="justify-center flex items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full mx-3 my-4 max-w-md">
          <div className="p-4 border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <button
              className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
              onClick={onClose}
              disabled={isSubmitting}
            >
              <span className="bg-transparent text-black w-10 block outline-none focus:outline-none text-lg font-semibold">
                <img
                  src="/img/closebutton.svg"
                  className="inline-block w-6"
                  alt="Close"
                />
              </span>
            </button>

            <h3 className="text-lg font-semibold mb-3">Complete Manual KYC</h3>

            <form onSubmit={handleSubmit(onSubmitForm)}>
              <div className="mb-4">
                <textarea
                  placeholder="Enter KYC reason"
                  className="w-full p-2 border rounded"
                  {...register('manualKycNote')}
                />
                {errors.manualKycNote && (
                  <p className="text-xs text-red-500">
                    {errors.manualKycNote.message}
                  </p>
                )}
              </div>
              <div className="flex justify-end items-end md:mb-0 mb-4">
                <div className="flex gap-3">
                  <button
                    type="button"
                    className="bg-[#AAAAAA] text-white px-4 py-2 rounded-md"
                    onClick={onClose}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className={
                      isSubmitting
                        ? 'bg-[#787a7d] cursor-not-allowed text-white font-bold uppercase text-sm px-5 py-3 rounded-md w-auto inline-block shadow hover:shadow-lg outline-none focus:outline-none mb-1 ease-linear transition-all duration-150'
                        : 'bg-GreenColor text-brandBlue text-base font-semibold px-4 py-2 rounded-md'
                    }
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <div className="flex items-center gap-2">
                        <CircleRunningIcon />
                      </div>
                    ) : (
                      'Submit'
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default ManualKycModal;
